import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface ConfirmActionProps {
  title: string;
  content: string;
  onConfirm: () => void;
  danger?: boolean;
}

export function confirmAction({ title, content, onConfirm, danger = false }: ConfirmActionProps) {
  Modal.confirm({
    title,
    icon: <ExclamationCircleOutlined />,
    content,
    okText: 'Confirm',
    okType: danger ? 'primary' : 'default',
    okButtonProps: danger ? { danger: true } : {},
    cancelText: 'Cancel',
    onOk: onConfirm,
  });
}
